import { apiClient } from './api'
import type { ApiResponse } from '@/types/api'
import type {
  Assignment,
  AssignmentSubmission,
  AssignmentWithLessonInfo,
  CreateAssignmentRequest,
  UpdateAssignmentRequest,
  CreateSubmissionRequest,
  GradeSubmissionRequest,
} from '@/types/assignment'

export const assignmentService = {
  // Assignment CRUD
  createAssignment: (data: CreateAssignmentRequest): Promise<ApiResponse<Assignment>> =>
    apiClient.post<Assignment>('/assignments', data),

  listAllAssignments: (): Promise<ApiResponse<AssignmentWithLessonInfo[]>> =>
    apiClient.get<AssignmentWithLessonInfo[]>('/assignments'),

  getAssignment: (id: string): Promise<ApiResponse<Assignment>> =>
    apiClient.get<Assignment>(`/assignments/${id}`),

  getAssignmentsByLesson: (lessonId: string): Promise<ApiResponse<Assignment[]>> =>
    apiClient.get<Assignment[]>(`/lessons/${lessonId}/assignments`),

  updateAssignment: (id: string, data: UpdateAssignmentRequest): Promise<ApiResponse<Assignment>> =>
    apiClient.put<Assignment>(`/assignments/${id}`, data),

  deleteAssignment: (id: string): Promise<ApiResponse<void>> =>
    apiClient.delete<void>(`/assignments/${id}`),

  publishAssignment: (id: string): Promise<ApiResponse<Assignment>> =>
    apiClient.post<Assignment>(`/assignments/${id}/publish`),

  // Submissions
  createSubmission: (
    assignmentId: string,
    data: CreateSubmissionRequest
  ): Promise<ApiResponse<AssignmentSubmission>> =>
    apiClient.post<AssignmentSubmission>(`/assignments/${assignmentId}/submissions`, data),

  getSubmission: (id: string): Promise<ApiResponse<AssignmentSubmission>> =>
    apiClient.get<AssignmentSubmission>(`/assignment-submissions/${id}`),

  getSubmissionsByAssignment: (assignmentId: string): Promise<ApiResponse<AssignmentSubmission[]>> =>
    apiClient.get<AssignmentSubmission[]>(`/assignments/${assignmentId}/submissions`),

  getStudentSubmissions: (
    assignmentId: string,
    enrollmentId: string
  ): Promise<ApiResponse<AssignmentSubmission[]>> =>
    apiClient.get<AssignmentSubmission[]>(
      `/assignments/${assignmentId}/my-submissions?enrollment_id=${enrollmentId}`
    ),

  gradeSubmission: (id: string, data: GradeSubmissionRequest): Promise<ApiResponse<void>> =>
    apiClient.post<void>(`/assignment-submissions/${id}/grade`, data),

  returnSubmission: (id: string, feedback: string): Promise<ApiResponse<void>> =>
    apiClient.post<void>(`/assignment-submissions/${id}/return`, { feedback }),

  deleteSubmission: (id: string): Promise<ApiResponse<void>> =>
    apiClient.delete<void>(`/assignment-submissions/${id}`),

  getSubmissionsByEnrollment: (enrollmentId: string): Promise<ApiResponse<AssignmentSubmission[]>> =>
    apiClient.get<AssignmentSubmission[]>(`/enrollments/${enrollmentId}/assignment-submissions`),
}
